import React from "react";
import { ShareButtons } from "react-share";
import PinterestIcon from "../Layout/Icons/PinterestIcon";
import FacebookIcon from "../Layout/Icons/FacebookIcon";

const { FacebookShareButton, PinterestShareButton } = ShareButtons;

const SocialIcons = ({ shareImageUrl, url, fbUrl, title }) => {
  return (
    <ul className="share-dialog__icons">
      <li className="share-dialog__icon-container">
        <div className="share-dialog__icon">
          <PinterestShareButton
            url={url}
            media={shareImageUrl}
            windowWidth={1000}
            windowHeight={730}
          >
            <PinterestIcon />
          </PinterestShareButton>
        </div>
        <h4>Pinterest</h4>
      </li>

      <li className="share-dialog__icon-container">
        <div className="share-dialog__icon">
          <FacebookShareButton url={fbUrl} quote={title}>
            <FacebookIcon />
          </FacebookShareButton>
        </div>
        <h4>Facebook</h4>
      </li>
    </ul>
  );
};

export default SocialIcons;
